<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-16 19:08:30
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/OnlineSearchSwitch.vue
-->
<template>
    <div class="mt-5">
        <div
            class="flex items-center justify-between gap-2 p-[10px] rounded-[10px] bg-tool-default-black border border-white/[.06]"
        >
            <label class="flex items-center text-white text-sm" :id="labelId">
                {{ t('menus.smart_online_search') }}
                <ClientOnly>
                    <el-popover
                        width="180"
                        :content="t('seo.textToImage.page.online_search')"
                    >
                        <template #reference>
                            <img
                                class="w-3 h-3 ml-2 cursor-help"
                                src="https://static.weryai.com/growth/image/4c8570087b6d87697059b93e7295b008.webp"
                                alt="info"
                                aria-hidden="true"
                                role="presentation"
                            />
                        </template>
                    </el-popover>
                </ClientOnly>
            </label>
            <div class="flex justify-center items-center gap-[10px]">
                <button
                    @click="use_web_search = !use_web_search"
                    type="button"
                    role="switch"
                    :aria-checked="use_web_search"
                    :aria-labelledby="labelId"
                    class="relative inline-flex h-6 w-11 items-center rounded-full transition-all duration-300"
                    :class="
                        use_web_search ? 'bg-switch-active-bg' : 'bg-white/10'
                    "
                >
                    <!-- 兜底：确保按钮始终有可访问名称（Lighthouse/axe 兼容） -->
                    <span class="sr-only">
                        {{ t('menus.smart_online_search') }}
                    </span>
                    <span
                        class="inline-block h-4 w-4 transform rounded-full transition-transform"
                        :class="
                            !use_web_search
                                ? 'translate-x-1 bg-white'
                                : 'translate-x-6 bg-switch-active-dot'
                        "
                    ></span>
                </button>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useId } from 'vue'
import { useI18n } from '../../composables/useI18n'

const { t, locale } = useI18n()
const labelId = useId()

const use_web_search = defineModel('use_web_search', {
    type: Boolean,
    default: true,
})
</script>
<style scoped lang="less">
.hidden-scrollbar {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
    }
}
</style>
